import { render, staticRenderFns } from "./SingleLayout.vue?vue&type=template&id=db564b06"
import script from "./SingleLayout.vue?vue&type=script&lang=js"
export * from "./SingleLayout.vue?vue&type=script&lang=js"
import style0 from "./SingleLayout.vue?vue&type=style&index=0&id=db564b06&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports